export default {
  MENU_OPEN: 'MENU_OPEN',
  MENU_CLOSE: 'MENU_CLOSE',
  MENU_ITEM_SELECT: 'MENU_ITEM_SELECT',
  TOGGLE_DRAG_AND_DROP: 'TOGGLE_DRAG_AND_DROP',
  SEARCH_CHANGED: 'SEARCH_CHANGED'
};
